import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { TiraBotonesView, BotonesInicio } from "./items/tirabotones";
import { Rastreo } from "./items/rastreo";
import { Facturacion } from "./items/facturaciononline";

import { CotizadorButton } from "./items/botones";
import { Footer } from "./items/footer";

import { Nosotros, Servicios, Cobertura, Sucursales, Contacto, AvisoPrivacidad, AvisoPrivacidad2 } from "./items/secciones";
import { PopupModal } from "./items/popupmodal"

const img = {
    paquete: require("app/img/paquete.png"),
    header: require("app/img/header.png"),
    slide: require("app/img/slide.png"),
    chico: require("app/img/chico.png"),
    popup: require("app/img/Popup.png")
}

export class Inicio extends React.PureComponent {
    render() {
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "681px"
                }}
            >
                <img src={img.slide}
                    style={{
                        flex: "0 1 auto"
                    }}
                />

                <img src={img.chico} style={{ flex: "0 1 auto", width: "100%", height: "auto" }} />
            </div>
        );
    }
}



export class PaginaInicio extends React.PureComponent<{}, { selected: BotonesInicio }> {
    constructor(props) {
        super(props);
        this.state = {
            selected: "inicio"
        }
    }
    private modals = kea.createModalManager();

    componentDidMount = async () => {
        const data = await resources.ConfigSistema.GetAnuncioInicio();
        if (data != null) {
            const blob = kea.base64ToBlob(data);
            const result = this.modals.showModal(PopupModal, { image: blob }, undefined);
        }
    }

    render() {
        const selected = this.state.selected;

        return (
            <div
                style={{
                    display: "flex"
                }}
            >
                <div style={{ flex: "1 0 auto" }} />
                <div
                    style={{
                        flex: "0 1 auto"
                    }}
                >
                    <img src={img.header} />
                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ flex: "0 1 auto" }}>
                            <TiraBotonesView selected={selected} onChange={x => this.setState({ selected: x })} />
                            {
                                selected == "inicio" ? <Inicio /> :
                                    selected == "nosotros" ? <Nosotros /> :
                                        selected == "servicios" ? <Servicios /> :
                                            selected == "cobertura" ? <Cobertura /> :
                                                selected == "sucursales" ? <Sucursales /> :
                                                    selected == "contacto" ? <Contacto /> :
                                                        selected == "aviso" ? <AvisoPrivacidad /> :
                                                            null
                            }
                        </div>

                        {/* Margen */}
                        <div style={{ flex: "0 1 auto", width: "10px" }} />


                        <div style={{ display: "flex", flexDirection: "column", flex: "0 1 auto" }} >
                            <div style={{ flex: "0 1 auto", height: "34px", marginBottom: "10px" }}>
                                <kea.Link iconClass={fa("user")} onClick={() => history.go("/login")} >
                                    Iniciar sesión
                                </kea.Link>
                            </div>

                            <div style={{ flex: "0 1 auto" }}>
                                <Rastreo />
                            </div>

                            <div style={{ flex: "0 1 auto", marginTop: "3px" }}>
                                <Facturacion />
                            </div>
                            <div style={{ flex: "0 1 auto", marginTop: "3px" }}>
                                <CotizadorButton />
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: "2px" }}>
                        <Footer selected={selected} onChange={x => this.setState({ selected: x })} />
                    </div>
                </div>

                <div style={{ flex: "1 0 auto" }} />
                {this.modals.component}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/features/general/diseño/index.tsx